import qs from 'querystring';
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

// ------------------------------------
// Contants
// ------------------------------------

export const RECEIVE_LIST = `ACCOUNT_RECEIVE_LIST`

export const RECEIVE_ROLE_LIST = `ACCOUNT_RECEIVE_ROLE_LIST`

export const SHOW_NEW_USER_MODAL = `ACCOUNT_SHOW_NEW_USER_MODAL`

export const SHOW_MODAL = `ACCOUNT_SHOW_MODAL`

export const HIDE_MODAL = `ACCOUNT_HIDE_MODAL`

export const DEFAULT_SIZE = 10

export const CHANGE_PAGE = `ACCOUNT_CHANGE_PAGE`

export const CHANGE_SELECT_ROLE = `ACCOUNT_CHANGE_SELECT_ROLE`

export const CHANGE_SEARCH_VALUE = `ACCOUNT_CHANGE_SEARCH_VALUE`

export const ADD_USER = `ACCOUNT_ADD_USER`

export const SHOW_USER_MODAL = `ACCOUNT_SHOW_USER_MODAL`


function getData(params,dispatch) {
    return http.get(`/account/list?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}

export function getList() {
    return (dispatch,getState) => {
        const {userManagement: {page,search}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        if (search.value) {
            data['searchValue'] = search.value
        }
        getData(data,dispatch);
    }
}

export function add(body) {
    return (dispatch,getState) => {
        dispatch({type: HIDE_MODAL})
        return http.post(`/account/add`,body)
            .then(() => {
                getList()(dispatch,getState)
            })
    }
}

// export function deleteRole(id) {
//     return (dispatch,getState) => {
//         return http.get(`/account/delete/${id}`)
//         .then(() => {
//             dispatch({type: HIDE_MODAL})
//             getList()(dispatch,getState)
//         })
//     }
// }

export function update(id,body) {
    return (dispatch,getState) => {
        return http.post(`/account/update/${id}`,body)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                getList()(dispatch,getState)
            })
    }
}
export function changeRole(roleId) {
    return (dispatch,getState) => {
        const {userManagement: {showModal: {id}}} = getState()
        return http.get(`/account/change-role/${id}?roles=${roleId}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                getList()(dispatch,getState)
            })
    }
}
export function getRoleList() {
    return (dispatch,getState) => {
        return http.get(`/role/list?size=1000`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_ROLE_LIST,
                    data: data.data.list
                })
            })
    }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    list: [],
    roleList: [],
    total: 0,
    formValue:{
        role: [],
        isActive: 'N',
    },
    showModal: {
        changeRole: false,
        id: null,
        row: null,
        curRoles: []
    },
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    search: {
        key: 'searchValue',
        value: ''
    },
    userInfo: {
        add: false,
        status: false,
        row: null,
        isActive: ''
    }
}
export default createReducer(initialState, {
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [RECEIVE_ROLE_LIST]: (state,{data}) => {
        return {...state,roleList: data}
    },
    [SHOW_NEW_USER_MODAL]: (state) => {
        return {...state,newUser: {open: true} }
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal,openMenu: null,userInfo: initialState.userInfo}
    },
    [SHOW_MODAL]: (state,{key,id,row,curRoles}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id,row,curRoles}}
    },
    [SHOW_USER_MODAL]: (state,{key,row,isActive}) => {
        return {...state,userInfo: {...state.userInfo,[key]: true,row,isActive}}
    },
    [CHANGE_SELECT_ROLE]: (state,{value}) => {
        return {...state,showModal:{...state.showModal,curRoles: value}}
    },
    [CHANGE_PAGE]: (state,{page}) => {
        return {...state,page}
    },
    [CHANGE_SEARCH_VALUE]: (state,{value}) => {
        return {...state,search: {...state.search,value}}
    },
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/user/reducers/list.js